import PropTypes from 'prop-types';

import { getColor } from 'basic-components';

import { customInsightSelectors } from 'selectors/modules/insight/custom';

import { PortWidget as StormPortWidget } from '@projectstorm/react-diagrams';

import classNames from 'classnames';
import './PortWidget.scss';

const { useFromInsightTile } = customInsightSelectors
const useLinksLength = ({ tileIndex }) => {
  const links = useFromInsightTile({ tileIndex, paramName: "links" })
  return links?.length
}
/* key on div is to force rerender when ports are connected */
const PortWidget = ({
  inputPort,
  engine,
  outputPort,
  text = "",
  tileIndex,
  width = undefined,
  ref
}) => {
  const linksLength = useLinksLength({ tileIndex }),
        activePortType = useFromInsightTile({ tileIndex, paramName: "activePortType" }),
        activePortIsInput = useFromInsightTile({ tileIndex, paramName: "activePortIsInput" }),
        activeId = useFromInsightTile({ tileIndex, paramName: "activeNodeId" })

  return (
    <div
        className="insight-node-widget__port"
        key={"insight-node-widget__port" + inputPort?.id + outputPort?.id + linksLength + activePortType + width}
        style={{ width }}
    >
      {inputPort && (
        <StormPortWidget 
            className="insight-node-widget__port__main insight-node-widget__port__main--input"
            engine={engine}
            port={inputPort}
        >
          <div 
              className={classNames(
                "insight-node-widget__port__main__circle-out",
                { "insight-node-widget__port__main__circle-out--highlighted": inputPort?.getType() === activePortType && inputPort?.isInput() !== activePortIsInput && activeId !== inputPort?.parent?.options?.id }
              )}
            >
            <div
                className="insight-node-widget__port__main__circle-out__inner"
                style={{
                  backgroundColor: Object.keys(inputPort?.links || {}).length > 0 ? getColor("blue-sky") : getColor("grey-base")
                }} 
            />
          </div>
        </StormPortWidget>
      )}
      {outputPort && (
        <StormPortWidget 
            className="insight-node-widget__port__main insight-node-widget__port__main--output"
            engine={engine}
            port={outputPort}
        >
          <div className="insight-node-widget__port__main__circle-out">
            <div
                className="insight-node-widget__port__main__circle-out__inner"
                style={{
                  backgroundColor: Object.keys(outputPort?.links || {}).length > 0 ? getColor("blue-sky") : getColor("grey-base")
                }} 
            />
          </div>
        </StormPortWidget>
      )}
      <div className="insight-node-widget__port__content">
        <div className="insight-node-widget__port__content__text">
          <p 
              className="insight-node-widget__port__content__text__main"
              ref={ref}
          >
            {text}
          </p>
        </div>
      </div>
    </div>
  )
}

PortWidget.displayName = "PortWidget"


PortWidget.propTypes = {
  engine: PropTypes.object.isRequired,
  inputPort: PropTypes.object.isRequired,
  outputPort: PropTypes.object.isRequired,
  text: PropTypes.string,
  tileIndex: PropTypes.number.isRequired,
  width: PropTypes.string
}

export default PortWidget;